const GetEBoolName = (id) => {
    switch (id) {
        case 1: { return "Yes" }
        case 0: { return "No" }
    }
}

const GetEBool = {
    EBool: [
        { Id: 1, Name: "Yes" },
        { Id: 0, Name: "No" },
    ]
}
const EBoolBg = (id) => {
    switch (id) {
        case 0: return "bg-red-400"
        case 1: return "bg-green-400"
    }
}
export { GetEBoolName, GetEBool, EBoolBg }
